export default "__VITE_ASSET__ea45a049__"